import { CardContent, CardHeader, Stack } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import MaterialTypography from "../../../components/MaterialTypography"
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "../../../context/popup";
import { useLoading } from "../../../components/Loading";
import { useEffect, useState } from "react";
import MaterialButton from "../../../components/MaterialButton";
import { Add, FilterAlt } from "@mui/icons-material";
import Table from "../../../components/Table";
import { setCurrentPage, setRowsPerPage, setTotalPages } from "./store/index.js";
import { deleteData, fetchData } from "../../../services/index.js";
import FieldDictionaryFilterDialog from './components/FieldDictionaryFilterDialog.js';

const FieldDictionaryList = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();

    const currentPage = useSelector((state) => state?.apiFieldDictionaryStore?.currentPage);
    const rowsPerPage = useSelector((state) => state?.apiFieldDictionaryStore?.rowsPerPage);
    const totalPages = useSelector((state) => state?.apiFieldDictionaryStore?.totalPages);

    const [insurerRegistryData, setInsurerRegistryData] = useState([]);
    const [isRefresh, setIsRefresh] = useState(false);
    const [search, setSearch] = useState("");
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [filterData, setFilterData] = useState({
        isActive: "",
        fieldCategoryId: "",
        gProductId: "",
        widgetTypeId: "",
        dataTypeId: ""
    });

    useEffect(() => {
        fetchFieldDictionaryList();
    },[isRefresh, currentPage, rowsPerPage, search])

    //List API
    const fetchFieldDictionaryList = async () => {
        setCircleLoading(true);
        try {     
        let url = `/api-engine/field-dictionary?page=${currentPage}&limit=${rowsPerPage}&searchTerm=${search}`;
                              
        //for active and inactive status
        if(filterData.isActive !== "") {
            url += `&isActive=${filterData.isActive}`;
        }
        if(filterData.gProductId !== "") {
            url += `&gProductId=${filterData.gProductId}`;
        }
        if(filterData.fieldCategoryId !== "") {
            url += `&fieldCategoryId=${filterData.fieldCategoryId}`;
        }
        if(filterData.widgetTypeId !== "") {
            url += `&widgetTypeId=${filterData.widgetTypeId}`;
        }
        if(filterData.dataTypeId !== "") {
            url += `&dataTypeId=${filterData.dataTypeId}`;
        }
  
        const response = await fetchData(url);
        if(response?.success){
            setInsurerRegistryData(response?.data?.items);
            dispatch(setTotalPages(response?.data?.totalPages));     
        }
        else{
            //throw error
            showSnackbar("Error Fetching Insurer Api List", "error")
        }
        } catch (error) {
            console.error('Error Fetching Insurer Api List:', error);
            showSnackbar(error?.response?.data?.message || "Network Error", "error")
        }
        finally{
            setCircleLoading(false);
        }
    };

    //delete api function
    const handleDelete = async (row) => {
        try {
            const response = await deleteData(`/api-engine/field-dictionary-delete`, {ids:[row?.id]});
            setIsRefresh(!isRefresh);
            if(response?.success){
                showSnackbar(response?.message, "success");
            }
            else{
                showSnackbar(response?.message, "error");
            }
        } catch (error) {
            console.error("Error deleting data:", error);
            showSnackbar(error?.response?.data?.message || "Error deleting Insurer Registry data", "error");
        }
    };

    //table mapping
    const fieldDictionaryTable = {
        columns: [
            {
            key: "sno",
            label: "S.No.",
            renderCell: (row) => row.sno,
            },            
            {
            key: "name",
            label: "Name",
            renderCell: (row) => row.name,
            },
            {
            key: "label",
            label: "Label",
            renderCell: (row) => row.label,
            },
            {
            key: "dataType",
            label: "Data Type",
            renderCell: (row) => row.dataType,
            },
            {
            key: "fieldCategory",
            label: "Field Category",
            renderCell: (row) => row.fieldCategory,
            },
            {
                key: "isActive",
                label: "Status",
                renderCell: (row) => (
                    <span>
                    {row.isActive ? (
                        <span style={{ color: "green", fontWeight: "bold" }}>Active</span>
                    ) : (
                        <span style={{ color: "red", fontWeight: "bold" }}>Inactive</span>
                    )}
                    </span>
                )
            },
            {
                key: "isRequired",
                label: "Required",
                renderCell: (row) => (
                    <span>
                    {row.isRequired ? (
                        <span style={{ color: "green", fontWeight: "bold" }}>Yes</span>
                    ) : (
                        <span style={{ color: "red", fontWeight: "bold" }}>No</span>
                    )}
                    </span>
                )
            },
        ],
        rows: insurerRegistryData?.map((item, index) => ({
            id: item?.id,
            sno: index + 1,
            fieldCategory: item?.fieldCategory?.keyName || "",
            name: item?.name || "",
            label: item?.label || "",
            dataType: item?.dataType?.keyName || "",
            isActive: item?.isActive,
            isRequired: item?.isRequired
        })),
    };

    const actions = {
        edit: true,
        view: true,
        delete: true,

        onEdit: (row) => {
            navigate(`/api-integration-engine/field-dictionary/field-dictionary-details?pageType=edit&id=${row.id}`);
        },
        onView: (row) => {
            navigate(`/api-integration-engine/field-dictionary/field-dictionary-details?pageType=view&id=${row.id}`);
        },
        onDelete: (row) => handleDelete(row),
    };

    const handlePaginationChange = (page) => {
        dispatch(setCurrentPage(page));
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        dispatch(setRowsPerPage(rowsPerPage));
        dispatch(setCurrentPage(1));
    };

    const handleSearch = (value) => {
        setSearch(value);
    };

  return (
    <DashboardLayout>
        <CardHeader title={(
            <Stack
            direction={{ xs: "column", sm: "row" }}
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            >
                <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                        Field Dictionary List
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                        List of Field Dictionary.
                    </MaterialTypography>
                </Stack>
                <Stack direction="row" spacing={1}>
                    <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<FilterAlt/>}
                    onClick={(event) => setAnchorEl(event.currentTarget)}
                    >
                    Filter
                    </MaterialButton>
                    <MaterialButton
                        variant="gradient"
                        color="dark"
                        size="small"
                        startIcon={<Add />}
                        onClick={() => navigate('/api-integration-engine/field-dictionary/field-dictionary-details')}
                    >
                        Field Dictionary
                    </MaterialButton>
                </Stack>
            </Stack>
            )} 
        />
        <CardContent>
            <Table
            columns={fieldDictionaryTable?.columns}
            data={fieldDictionaryTable?.rows}
            actions={actions}
            pagination={{
                totalPages,
                currentPage,
                onPageChange: (page) => handlePaginationChange(page),
                rowsPerPage,
                onRowsPerPageChange: (rowsPerPage) => handleRowsPerPageChange(rowsPerPage),
                rowsPerPageOptions: [5, 10, 15, 20],
            }}
            getRowKey={(row) => row.id}
            className="custom-table"
            noDataLabel="No Field Dictionary Data found"
            handleSearch={handleSearch}
            />
        </CardContent>
        <FieldDictionaryFilterDialog
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        filterData={filterData}
        setFilterData={setFilterData}
        onApply={() => {
            setAnchorEl(null);   // close popup
            fetchFieldDictionaryList();  // call API after filter applied
        }}
        />
    </DashboardLayout>
  )
}

export default FieldDictionaryList